import UIAlert from 'UIComponents/alert/UIAlert';
import UILink from 'UIComponents/link/UILink';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const QuarantinedMessageAlert = ({
  shouldRenderPreviewAlert
}) => {
  const title = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "conversations-inbox-message-history.common-message.quarantinedMessage.header"
  });
  if (shouldRenderPreviewAlert) {
    return /*#__PURE__*/_jsx(UIAlert, {
      type: "danger",
      style: {
        minHeight: '35px'
      },
      children: title
    });
  }
  return /*#__PURE__*/_jsx(UIAlert, {
    type: "danger",
    titleText: title,
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "conversations-inbox-message-history.common-message.quarantinedMessage.body_jsx",
      options: {},
      elements: {
        UILink
      }
    })
  });
};
QuarantinedMessageAlert.displayName = 'QuarantinedMessageAlert';
export default QuarantinedMessageAlert;